/**
 * This variable contains all the information that comes from WordPress via wp_localize_script
 */

const isProd = process.env.NODE_ENV === 'production'
// @ts-ignore
const wpSettings = isProd ? imotWPSettings : null

export const WPSettings = {
  API_URL: isProd ? wpSettings.api_url : 'https://wpdev.ddev.site/wp-json/imot/v1',
  ROUTER_PATH: isProd ? wpSettings.path : '/',
  ASSETS_DIR: isProd ? wpSettings.plugin_dir + 'static' : '/static',
  NONCE: isProd ? wpSettings.nonce : '3b07a18c76',
  LANGUAGE: isProd ? wpSettings.current_language : 'nl',
}
